import { render } from "./TheContacts.vue?vue&type=template&id=40cded7f&scoped=true"
const script = {}

import "./TheContacts.vue?vue&type=style&index=0&id=40cded7f&scoped=true&lang=scss"

import exportComponent from "D:\\frontend\\finans\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40cded7f"]])

export default __exports__